import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const items = [
  {
    quote:
      "APEX gave our website a completely new direction. The design looks premium, the SEO structure is much stronger, and our inquiries improved within weeks.",
    name: "Priya Ramesh",
    role: "Founder, Northline Studio",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "They actually understood our funnel before touching a single pixel. The launch was calm, the numbers moved fast, and we finally have a site that sells for us.",
    name: "Marcus Alden",
    role: "Head of Growth, Trellis SaaS",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "The APEX team feels like an in-house partner. Weekly experiments, clear reporting, and design that our board is genuinely proud of.",
    name: "Sofia Delgado",
    role: "CMO, Bright & Co.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="section-pad relative">
      <div className="container-apex">
        <div className="max-w-3xl">
          <div className="eyebrow mb-4"><span className="w-6 h-px bg-apex-cyan" /> Client love</div>
          <h2 className="text-4xl md:text-5xl font-extrabold leading-[1.05]">
            What our clients say <span className="text-apex-orange">after launch.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="glass glass-hover glass-inner-glow p-7 relative overflow-hidden"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute -top-2 -left-2 w-24 h-24 text-white/[0.04]" strokeWidth={1} />
              <div className="flex items-center gap-1 text-apex-orange">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-current" strokeWidth={0} />
                ))}
              </div>
              <blockquote className="mt-5 text-white/85 text-[15px] leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden ring-2 ring-white/15 shrink-0">
                  <img src={t.avatar} alt={t.name} loading="lazy" className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold">{t.name}</div>
                  <div className="text-xs text-white/60">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
